import * as React from 'react';
import { LoaderIcon } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import * as styles from './Spinner.css';

export interface ISpinnerProps {
  size?: number;
}

export function Spinner({ size }: ISpinnerProps) {
  return (
    <div {...mergeStyles(styles['container'], { height: size, width: size })}>
      <LoaderIcon custom={{ hoveredColor: 'FFFFFF', size: '100%' }} styles={{ color: 'FFFFFF' }} />
    </div>
  );
}
